import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router";
import i18n from "@/i18n";
import {LIMITED_GROUP} from "@/helpers/access";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    lang: localStorage.getItem('lang') || 'en',
    // tb_user.group_id of the backend user (4 = policy check + report only)
    group_id: Number(localStorage.getItem('group_id')) || 0

  },
  getters: {
    isLoggedIn: state => !!state.token,
    getLang: state => state.lang,
    isLimited: state => state.group_id === LIMITED_GROUP

  },
  mutations: {
    auth_success(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    async logout(state) {
      state.token = ''
      localStorage.removeItem('token')
      state.group_id = 0
      localStorage.removeItem('group_id')
      await router.push({path: '/login'})
    },
    set_group(state, group_id) {
      state.group_id = Number(group_id) || 0
      localStorage.setItem('group_id', state.group_id)
    },
    setLang(state, lang) {
      state.lang = lang
      localStorage.setItem('lang', lang)
      i18n.locale=lang
    }
  },
  actions: {
    login({commit}, token) {
      commit('auth_success', token)
    },
    setGroup({commit}, group_id) {
      commit('set_group', group_id)
    },
    logout({commit}) {
      commit('logout')
    },
    setLang({commit}, lang) {
      commit('setLang', lang)
    }
  },
  modules: {}
})
